import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated collections list
 */
export default class CollectionsMenuList extends PaginatedList {
  #filterSelect;
  #grid;
  #emptyMessage;
  #filterObserver;

  connectedCallback() {
    super.connectedCallback();
    this.#setupFilter();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#teardownFilter();
  }

  #setupFilter() {
    const form = this.querySelector('[data-menu-collections-filters]');
    const filterSelect = form?.querySelector('[name="filtro"]');
    const grid = this.querySelector('[ref="grid"]');
    if (!form || !(filterSelect instanceof HTMLSelectElement) || !grid) {
      this.removeAttribute('data-filter-ready');
      return;
    }

    this.#filterSelect = filterSelect;
    this.#grid = grid;
    this.#emptyMessage = this.querySelector('[data-menu-collections-empty]') || null;

    this.#filterObserver?.disconnect();
    this.#filterObserver = new MutationObserver(() => this.#applyFilter());
    this.#filterObserver.observe(grid, { childList: true, subtree: true });

    this.#filterSelect.addEventListener('change', this.#onFilterChange);
    window.addEventListener('pageshow', this.#syncFilterFromUrl);
    this.setAttribute('data-filter-ready', 'true');
    this.#syncFilterFromUrl();
  }

  #teardownFilter() {
    this.#filterSelect?.removeEventListener('change', this.#onFilterChange);
    window.removeEventListener('pageshow', this.#syncFilterFromUrl);
    this.#filterObserver?.disconnect();
    this.#filterObserver = undefined;
    this.removeAttribute('data-filter-ready');
  }

  #onFilterChange = () => {
    const value = this.#filterSelect?.value || 'all';
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    if (value !== 'all') {
      url.searchParams.set('filtro', value);
    } else {
      url.searchParams.delete('filtro');
    }
    history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    this.#applyFilter();
  };

  #syncFilterFromUrl = () => {
    if (!this.#filterSelect) return;
    const params = new URLSearchParams(window.location.search);
    const val = params.get('filtro') || 'all';
    const exists = Array.from(this.#filterSelect.options).some((opt) => opt.value === val);
    this.#filterSelect.value = exists ? val : 'all';
    this.#applyFilter();
  };

  #applyFilter() {
    if (!this.#filterSelect || !this.#grid) return;

    const value = this.#filterSelect.value || 'all';
    const token = value === 'all' ? '' : `|${value}|`;
    let visibleCount = 0;
    const cards = this.#grid.querySelectorAll('.menu-collections__item[data-filter-keys]');

    cards.forEach((card) => {
      const keys = card.getAttribute('data-filter-keys') || '|';
      const isVisible = token === '' || keys.includes(token);
      card.classList.toggle('menu-collections__item--hidden', !isVisible);
      if (isVisible) visibleCount += 1;
    });

    if (this.#emptyMessage) {
      this.#emptyMessage.hidden = visibleCount !== 0;
    }
  }
}

if (!customElements.get('collections-menu-list')) {
  customElements.define('collections-menu-list', CollectionsMenuList);
}
